import { Box, MainContainer } from "../../../styles/basicStyles";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import { BannerCircle1, BannerCircle2 } from "./styles";
import Typography from "../../../components/typography";
import Dot from "../../../components/views/dot";

interface BannerProps {
  title: string;
}

const Banner: FC<BannerProps> = ({ title }) => {
  return (
    <Box
      bgColor={colors.chineseBlack}
      pt={{ md: 10.063, xxs: 7.5 }}
      pb={{ md: 7.625, xxs: 5.625 }}
      position='relative'
      overflow='hidden'
    >
      <BannerCircle1 />
      <BannerCircle2 />
      <MainContainer>
        <Box
          fJustify={{ md: "center", xxs: "flex-start" }}
          fAlign={{ md: "center", xxs: "flex-start" }}
          position='relative'
          zIndex={3}
        >
          <Typography
            fSize={{ md: 3.125, xxs: 2.313 }}
            lHeight={{ md: 3.75, xxs: 2.938 }}
            fWeight={700}
            style={{ color: colors.white }}
            mt={{ md: 0.688, xxs: 0.625 }}
          >
            {title}
            <Dot
              w={{ md: 0.875, xxs: 0.5 }}
              h={{ md: 0.875, xxs: 0.5 }}
              ml={0.375}
            />
          </Typography>
        </Box>
      </MainContainer>
    </Box>
  );
};

export default Banner;
